function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.5 34C26.4624 34 24 36.4624 24 39.5V52.0024V84.8184V97.3227C24 100.36 26.4624 102.823 29.5 102.823H107.5C110.538 102.823 113 100.36 113 97.3227V84.8184V52.0024V39.5C113 36.4624 110.538 34 107.5 34H29.5ZM110 48.5378V39.5C110 38.1193 108.881 37 107.5 37H101V48.5024H109.5C109.67 48.5024 109.837 48.5144 110 48.5378ZM98 37H88.5996V48.5024H98V37ZM85.5996 37H76.2012V48.5024H85.5996V37ZM73.2012 37H63.7988V48.5024H73.2012V37ZM60.7988 37H51.4004V48.5024H60.7988V37ZM48.4004 37H39V48.5024H48.4004V37ZM36 37H29.5C28.1193 37 27 38.1193 27 39.5V48.5378C27.1633 48.5144 27.3302 48.5024 27.5 48.5024H36V37ZM27 52.0024V84.8184C27 85.0946 27.2239 85.3184 27.5 85.3184H109.5C109.776 85.3184 110 85.0946 110 84.8184V52.0024C110 51.7262 109.776 51.5024 109.5 51.5024H27.5C27.2239 51.5024 27 51.7262 27 52.0024ZM110 88.283C109.837 88.3064 109.67 88.3184 109.5 88.3184H101V99.8227H107.5C108.881 99.8227 110 98.7034 110 97.3227V88.283ZM98 99.8227V88.3184H88.5996V99.8227H98ZM85.5996 99.8227V88.3184H76.2012V99.8227H85.5996ZM73.2012 99.8227V88.3184H63.7988V99.8227H73.2012ZM60.7988 99.8227V88.3184H51.4004V99.8227H60.7988ZM48.4004 99.8227V88.3184H39V99.8227H48.4004ZM36 99.8227V88.3184H27.5C27.3302 88.3184 27.1633 88.3064 27 88.283V97.3227C27 98.7034 28.1193 99.8227 29.5 99.8227H36Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80 67.9601C80.6667 68.345 80.6667 69.3073 80 69.6922L63.5 79.2185C62.8333 79.6034 62 79.1223 62 78.3525L62 59.2999C62 58.5301 62.8333 58.049 63.5 58.4339L80 67.9601Z"
});

var SvgCulture = function SvgCulture(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCulture, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/culture.17ef39da.svg";
export { ForwardRef as ReactComponent };